import { ExtendedCurrencies } from '@constants/enums';
import useEffectOnce from '@main-hooks/useEffectOnce';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useApiCall } from 'use-api-call';
import { useAppDispatch } from '@/store';
import { addNewWalletDataReducer } from '@/modules/wallets/store';
import newWalletModalServices from '../../../services/NewWalletModal.service';
import {
  UseCreateAccountProps,
  UseCreateAccountReturn,
} from '../types/UseCreateAccount.types';

const useCreateAccount = ({
  selectedCurrency,
  onGoToNextStep,
}: UseCreateAccountProps): UseCreateAccountReturn => {
  const userProfile = useSelector(selectProfileData);
  const enterpriseId = userProfile?.company.enterpriseId || '0';

  const dispatch = useAppDispatch();

  const {
    invoke: createWallet,
    data,
    loading: isCreatingWallet,
    error,
  } = useApiCall(() =>
    newWalletModalServices.createWallet({
      enterpriseId,
      currency: selectedCurrency.currency as
        | ExtendedCurrencies.EUR
        | ExtendedCurrencies.GBP,
    })
  );

  useEffectOnce(() => {
    createWallet();
  });

  useEffect(() => {
    if (isCreatingWallet) return;

    if (data) {
      dispatch(addNewWalletDataReducer(data));
      onGoToNextStep(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isCreatingWallet]);

  return { error, isCreatingWallet, createWallet };
};

export default useCreateAccount;
